import { PROVINCES } from '../context/RegionContext';
import { deliveryCharges } from './deliveryLocations';

const chargeEntries = Object.entries(deliveryCharges).flatMap(([charge, areas]) => areas.map((area) => ({ area, charge: Number(charge) })));
const allAreas = chargeEntries.map(({ area }) => area);

const nonOntarioAreas = new Set([
  'Calgary', 'Edmonton', 'Red Deer',
  'Vancouver', 'Surrey', 'Burnaby',
  'Montreal', 'Quebec City', 'Laval', 'Longueuil', 'Brossard', 'Châteauguay', 'Saint-Lambert',
]);

export const DELIVERY_PROVINCES = PROVINCES;

export const DELIVERY_AREAS_BY_PROVINCE = {
  ontario: allAreas.filter((area) => !nonOntarioAreas.has(area)),
  alberta: ['Calgary', 'Edmonton', 'Red Deer'],
  'british-columbia': ['Vancouver', 'Surrey', 'Burnaby'],
  quebec: ['Montreal', 'Quebec City', 'Laval', 'Longueuil', 'Brossard', 'Châteauguay', 'Saint-Lambert'],
};

export const DELIVERY_AREA_CHARGES = Object.fromEntries(chargeEntries.map(({ area, charge }) => [area, charge]));
export const ALL_DELIVERY_AREAS = Object.values(DELIVERY_AREAS_BY_PROVINCE).flat();

export const getDeliveryAreasForProvince = (provinceId) => DELIVERY_AREAS_BY_PROVINCE[provinceId] || [];
export const getDeliveryChargeLabel = (area) => `$${DELIVERY_AREA_CHARGES[area] ?? 0}`;
